<div class="c-no-result">
  <div class="row">
    <div class="col-12">
      <img :src="require('@/assets/icons/sidebars/no-result.svg')" alt="" />
    </div>
  </div>
  <div class="c-no-result-title">
    <span class="name">{{ $t('errorResult') }}</span>
    <span class="desc">{{ $t('errorResultMessage') }}</span>
  </div>
</div>
<!-- Sorry, there are no results for this search. Please try another phrase -->